import { ProductAttributes } from "@/features/productVariations";
import AddToCartBtn from "@/components/features/products/AddToCartBtn";
import ProductQuantity from "./ProductQuantity";
import { ProductType, type Product } from "@/types/products";
import type {
  AvailableTermsSetMap,
  DisplayPrices,
  SelectedTerms,
} from "@/features/productVariations";

interface AddToCartFormProps {
  product: Product;
  isPurchasable: boolean;
  displayPrices: DisplayPrices;
  selectedTerms: SelectedTerms;
  availableTermsSetMap: AvailableTermsSetMap;
  isVariationsLoading: boolean;
  handleAttributeSelect: (attributeName: string, termName: string) => void;
  quantity: number;
  maxQuantity: number | null;
  handleQuantityChange: (value: number) => void;
  isAddToCartLoading: boolean;
  handleAddToCart: (onSuccess?: () => void) => Promise<void>;
  closeBottomSheet?: () => void;
}

const AddToCartForm = ({
  product,
  isPurchasable,
  selectedTerms,
  availableTermsSetMap,
  isVariationsLoading,
  handleAttributeSelect,
  quantity,
  maxQuantity,
  handleQuantityChange,
  isAddToCartLoading,
  handleAddToCart,
  closeBottomSheet,
}: AddToCartFormProps) => {
  const showAttributes = product.type === ProductType.Variable && !!product.attributes?.length;

  return (
    <div>
      {/* Attributes */}
      {showAttributes && (
        <div className="mt-10">
          <ProductAttributes
            attributes={product.attributes}
            selectedTerms={selectedTerms}
            availableTermsSetMap={availableTermsSetMap}
            isLoading={isVariationsLoading}
            handleAttributeSelect={handleAttributeSelect}
          />
        </div>
      )}

      {/* Quantity */}
      <div className="brand-text-sm mb-2 mt-6 font-bold text-base-content">數量</div>
      <ProductQuantity
        quantity={quantity}
        maxQuantity={maxQuantity}
        handleQuantityChange={handleQuantityChange}
      />

      {/* Add Cart Btn */}
      <div className="mt-6">
        <AddToCartBtn
          disabled={isAddToCartLoading || !isPurchasable}
          isLoading={isAddToCartLoading}
          isPurchasable={isPurchasable}
          handleClick={() => handleAddToCart(closeBottomSheet)}
        />
      </div>
    </div>
  );
};

export default AddToCartForm;
